import React from 'react';
import ReactDOM from 'react-dom';

const state = {
    loadingArr: [require("./img/theLoading1.png"),
    require("./img/theLoading2.png"),
    require("./img/theLoading3.png"),
    require("./img/theLoading4.png"),
    require("./img/theLoading5.png"),
    require("./img/theLoading6.png"),
    require("./img/theLoading7.png"),
    require("./img/theLoading8.png"),
    require("./img/theLoading9.png"),
    require("./img/theLoading10.png"),
    require("./img/theLoading11.png"),
    require("./img/theLoading12.png"),
    require("./img/theLoading13.png"),
    require("./img/theLoading14.png"),
    require("./img/theLoading15.png"),
    require("./img/theLoading16.png"),
    require("./img/theLoading17.png"),
    require("./img/theLoading18.png"),
    require("./img/theLoading19.png"),
    require("./img/theLoading20.png"),
    require("./img/theLoading21.png"),
    require("./img/theLoading22.png"),
    require("./img/theLoading23.png"),
    require("./img/theLoading24.png"),
    require("./img/theLoading25.png")],
  }
let count=0;
var interVal
var show=() =>{
  console.log('hidden')
  document.getElementsByTagName('html')[0].style.overflowY='hidden';
  document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
	let isHave=document.getElementsByClassName('my-loading').length;
	if (isHave>0) {return} 
  let div;
  div = document.createElement('div');
  div.className = 'my-loading-box';  
  document.body.appendChild(div);
  ReactDOM.render(
	<div className='my-loading'>
		<img className='my-loading-img' src={state.loadingArr[count]}/>
		 <p>正在加载...</p>
	</div>
  	, div);
  start()
}
let start=()=>{
	let div=document.getElementsByClassName('my-loading-img');
	interVal = setInterval(() => {
    count++;
    if(count > 24) {
      count = 0;
    }
    div[0].setAttribute("src",state.loadingArr[count]);
  }, 50);
}
var hide=()=>{
  document.getElementsByTagName('html')[0].style.overflowY='auto';
  document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")

	count=0;
	let div=document.getElementsByClassName('my-loading-box');
	clearInterval(interVal);
  console.log(div)
  if (div.length>0) {
    div[0].remove()
  }
	
}
let Loading={
	show:show,
	hide:hide
}
export default Loading;


// WEBPACK FOOTER //
// ./src/Loading.js